/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteVendorCommand } from '../../models/delete-vendor-command';
import { DeleteVendorCommandResult } from '../../models/delete-vendor-command-result';

export interface ApiVendorsDeleteVendorDelete$Params {
  
    /**
     * The command containing the ID of the Vendor to delete.
     */
    body?: DeleteVendorCommand
}

export function apiVendorsDeleteVendorDelete(http: HttpClient, rootUrl: string, params?: ApiVendorsDeleteVendorDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteVendorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsDeleteVendorDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteVendorCommandResult>;
    })
  );
}

apiVendorsDeleteVendorDelete.PATH = '/api/Vendors/DeleteVendor';
